module.exports = __webpack_public_path__ + "static/forecast/weather/nightrainshowers-8b43848cad54f9e79d31602e36b0540f.svg";